<template>
  <div class="multiple-file-display">
    <template v-if="validFiles.length">
      <el-popover v-for="(file, index) in validFiles" :key="fileKey(file, index)" placement="top-start" trigger="click"
        append-to-body width="360" popper-class="multiple-file-display-popover">
        <div class="popover-preview-inner">
          <FilePreview :value="file.url" />
        </div>
        <el-tag slot="reference" type="info" size="small" class="file-item-tag">
          <span class="file-item-tag__text">{{ displayName(file) }}</span>
        </el-tag>
      </el-popover>
    </template>
    <span v-else class="multiple-file-display__empty">{{ emptyText }}</span>
  </div>
</template>

<script>
import FilePreview from "@/components/FilePreview";

export default {
  name: "MultipleFileDisplay",
  components: { FilePreview },
  props: {
    /**
     * 文件列表，每项含 name、url
     */
    files: {
      type: Array,
      default: () => []
    },
    emptyText: {
      type: String,
      default: "-"
    }
  },
  computed: {
    validFiles() {
      if (!Array.isArray(this.files)) {
        return [];
      }
      return this.files.filter((f) => f && typeof f.url === "string" && f.url);
    }
  },
  methods: {
    fileKey(file, index) {
      return `${index}-${file.url}`;
    },
    displayName(file) {
      if (file.name && String(file.name).trim()) {
        return file.name;
      }
      const url = file.url || "";
      const part = url.split(/[?#]/)[0];
      const seg = part.split("/").filter(Boolean).pop();
      return seg || url || "附件";
    }
  }
};
</script>

<style scoped lang="less">
.multiple-file-display {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}

.file-item-tag {
  max-width: 280px;
  cursor: pointer;

  .file-item-tag__text {
    display: inline-block;
    max-width: 260px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    vertical-align: middle;
    text-decoration: underline;
  }
}

.multiple-file-display__empty {
  color: #c0c4cc;
  font-size: 14px;
}
</style>

<style lang="less">
.multiple-file-display-popover {
  max-height: 72vh;
  overflow: hidden;
  padding: 12px 14px;
  box-sizing: border-box;
}

.multiple-file-display-popover .popover-preview-inner {
  max-width: 100%;
  overflow-x: hidden;
  box-sizing: border-box;
}
</style>
